var cov_2q67h61w2t = function () {
  var path = "/Users/spana/SHEIN/shineout/src/DatePicker/Time.tsx",
      hash = "7546d0c91de3c2f47796c9f418ddb32bc5f31075",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/DatePicker/Time.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 16
        }
      },
      "1": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 45
        }
      },
      "2": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 64
        }
      },
      "3": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 68
        }
      },
      "4": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 68
        }
      },
      "5": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 64
        }
      },
      "6": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 56
        }
      },
      "7": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 68
        }
      },
      "8": {
        start: {
          line: 35,
          column: 25
        },
        end: {
          line: 35,
          column: 35
        }
      },
      "9": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 63
        }
      },
      "10": {
        start: {
          line: 40,
          column: 14
        },
        end: {
          line: 40,
          column: 15
        }
      },
      "11": {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 41,
          column: 63
        }
      },
      "12": {
        start: {
          line: 42,
          column: 43
        },
        end: {
          line: 42,
          column: 53
        }
      },
      "13": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 46
        }
      },
      "14": {
        start: {
          line: 43,
          column: 35
        },
        end: {
          line: 43,
          column: 46
        }
      },
      "15": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 41
        }
      },
      "16": {
        start: {
          line: 44,
          column: 27
        },
        end: {
          line: 44,
          column: 41
        }
      },
      "17": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 80
        }
      },
      "18": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 48
        }
      },
      "19": {
        start: {
          line: 58,
          column: 74
        },
        end: {
          line: 58,
          column: 84
        }
      },
      "20": {
        start: {
          line: 59,
          column: 31
        },
        end: {
          line: 71,
          column: 6
        }
      },
      "21": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 54
        }
      },
      "22": {
        start: {
          line: 76,
          column: 23
        },
        end: {
          line: 76,
          column: 33
        }
      },
      "23": {
        start: {
          line: 77,
          column: 18
        },
        end: {
          line: 77,
          column: 33
        }
      },
      "24": {
        start: {
          line: 79,
          column: 37
        },
        end: {
          line: 79,
          column: 41
        }
      },
      "25": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      "26": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 86,
          column: 7
        }
      },
      "27": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 18
        }
      },
      "28": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 18
        }
      },
      "29": {
        start: {
          line: 88,
          column: 31
        },
        end: {
          line: 95,
          column: 34
        }
      },
      "30": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 26
        }
      },
      "31": {
        start: {
          line: 97,
          column: 20
        },
        end: {
          line: 97,
          column: 26
        }
      },
      "32": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 86
        }
      },
      "33": {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 113,
          column: 18
        }
      },
      "34": {
        start: {
          line: 115,
          column: 16
        },
        end: {
          line: 115,
          column: 23
        }
      },
      "35": {
        start: {
          line: 116,
          column: 14
        },
        end: {
          line: 210,
          column: 5
        }
      },
      "36": {
        start: {
          line: 212,
          column: 4
        },
        end: {
          line: 214,
          column: 5
        }
      },
      "37": {
        start: {
          line: 213,
          column: 6
        },
        end: {
          line: 213,
          column: 25
        }
      },
      "38": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 216,
          column: 14
        }
      },
      "39": {
        start: {
          line: 220,
          column: 41
        },
        end: {
          line: 220,
          column: 51
        }
      },
      "40": {
        start: {
          line: 221,
          column: 18
        },
        end: {
          line: 221,
          column: 33
        }
      },
      "41": {
        start: {
          line: 222,
          column: 22
        },
        end: {
          line: 222,
          column: 52
        }
      },
      "42": {
        start: {
          line: 224,
          column: 16
        },
        end: {
          line: 224,
          column: 32
        }
      },
      "43": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 227,
          column: 5
        }
      },
      "44": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 226,
          column: 17
        }
      },
      "45": {
        start: {
          line: 230,
          column: 16
        },
        end: {
          line: 230,
          column: 70
        }
      },
      "46": {
        start: {
          line: 231,
          column: 16
        },
        end: {
          line: 231,
          column: 70
        }
      },
      "47": {
        start: {
          line: 233,
          column: 4
        },
        end: {
          line: 233,
          column: 93
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 39
          },
          end: {
            line: 32,
            column: 3
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        loc: {
          start: {
            line: 34,
            column: 15
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 34
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 19
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 39
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        loc: {
          start: {
            line: 48,
            column: 13
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 48
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 73,
            column: 3
          }
        },
        line: 57
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        },
        loc: {
          start: {
            line: 75,
            column: 73
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 75
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 85
          },
          end: {
            line: 217,
            column: 3
          }
        },
        line: 101
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 219,
            column: 2
          },
          end: {
            line: 219,
            column: 3
          }
        },
        loc: {
          start: {
            line: 219,
            column: 11
          },
          end: {
            line: 234,
            column: 3
          }
        },
        line: 219
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 46
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 46
          }
        }],
        line: 43
      },
      "1": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        }],
        line: 44
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 11
          },
          end: {
            line: 49,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 11
          },
          end: {
            line: 49,
            column: 27
          }
        }, {
          start: {
            line: 49,
            column: 31
          },
          end: {
            line: 49,
            column: 48
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 72,
            column: 11
          },
          end: {
            line: 72,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 23
          },
          end: {
            line: 72,
            column: 33
          }
        }, {
          start: {
            line: 72,
            column: 36
          },
          end: {
            line: 72,
            column: 54
          }
        }],
        line: 72
      },
      "4": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }],
        line: 81
      },
      "5": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        }],
        line: 82
      },
      "6": {
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 26
          }
        }, {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 26
          }
        }],
        line: 97
      },
      "7": {
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 30
          }
        }, {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 134,
            column: 10
          }
        }],
        line: 117
      },
      "8": {
        loc: {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 154,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 136,
            column: 30
          }
        }, {
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 153,
            column: 10
          }
        }],
        line: 136
      },
      "9": {
        loc: {
          start: {
            line: 155,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 155,
            column: 6
          },
          end: {
            line: 155,
            column: 30
          }
        }, {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 171,
            column: 10
          }
        }],
        line: 155
      },
      "10": {
        loc: {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 190,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 30
          }
        }, {
          start: {
            line: 174,
            column: 8
          },
          end: {
            line: 189,
            column: 10
          }
        }],
        line: 173
      },
      "11": {
        loc: {
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 209,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 191,
            column: 24
          }
        }, {
          start: {
            line: 192,
            column: 8
          },
          end: {
            line: 208,
            column: 10
          }
        }],
        line: 191
      },
      "12": {
        loc: {
          start: {
            line: 200,
            column: 17
          },
          end: {
            line: 200,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 200,
            column: 77
          },
          end: {
            line: 200,
            column: 78
          }
        }, {
          start: {
            line: 200,
            column: 81
          },
          end: {
            line: 200,
            column: 82
          }
        }],
        line: 200
      },
      "13": {
        loc: {
          start: {
            line: 212,
            column: 4
          },
          end: {
            line: 214,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 212,
            column: 4
          },
          end: {
            line: 214,
            column: 5
          }
        }, {
          start: {
            line: 212,
            column: 4
          },
          end: {
            line: 214,
            column: 5
          }
        }],
        line: 212
      },
      "14": {
        loc: {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 227,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 227,
            column: 5
          }
        }, {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 227,
            column: 5
          }
        }],
        line: 225
      },
      "15": {
        loc: {
          start: {
            line: 225,
            column: 8
          },
          end: {
            line: 225,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 8
          },
          end: {
            line: 225,
            column: 32
          }
        }, {
          start: {
            line: 225,
            column: 36
          },
          end: {
            line: 225,
            column: 47
          }
        }],
        line: 225
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/DatePicker/Time.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { datepickerClass } from './styles';
import TimeScroll from './TimeScroll';
import utils from './utils';
import { isRTL } from '../config';
import paramUtils from './paramUtils';
import { getLocale } from '../locale';

var Time =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Time, _PureComponent);

  var _super = _createSuper2(Time);

  function Time(props) {
    var _this;

    _classCallCheck(this, Time);

    cov_2q67h61w2t.f[0]++;
    cov_2q67h61w2t.s[0]++;
    _this = _super.call(this, props);
    _this.defaultValue = void 0;
    _this.handleMinuteChange = void 0;
    _this.handleHourChange = void 0;
    _this.handleSecondChange = void 0;
    _this.handleAMPMChange = void 0;
    cov_2q67h61w2t.s[1]++;
    _this.defaultValue = _this.getDefaultTime();
    cov_2q67h61w2t.s[2]++;
    _this.handleHourChange = _this.handleChange.bind(_assertThisInitialized(_this), 'hour');
    cov_2q67h61w2t.s[3]++;
    _this.handleMinuteChange = _this.handleChange.bind(_assertThisInitialized(_this), 'minute');
    cov_2q67h61w2t.s[4]++;
    _this.handleSecondChange = _this.handleChange.bind(_assertThisInitialized(_this), 'second');
    cov_2q67h61w2t.s[5]++;
    _this.handleAMPMChange = _this.handleChange.bind(_assertThisInitialized(_this), 'ampm');
    cov_2q67h61w2t.s[6]++;
    _this.handleDisabled = _this.handleDisabled.bind(_assertThisInitialized(_this));
    cov_2q67h61w2t.s[7]++;
    props.disabledRegister(_this.handleDisabled, 'time', props.index);
    return _this;
  }

  _createClass(Time, [{
    key: "getOptions",
    value: function getOptions() {
      cov_2q67h61w2t.f[1]++;

      var _ref = (cov_2q67h61w2t.s[8]++, this.props),
          timeZone = _ref.timeZone;

      cov_2q67h61w2t.s[9]++;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "getDefaultTime",
    value: function getDefaultTime() {
      cov_2q67h61w2t.f[2]++;
      var idx = (cov_2q67h61w2t.s[10]++, 0);
      var current = (cov_2q67h61w2t.s[11]++, utils.newDate(undefined, this.getOptions()));

      var _ref2 = (cov_2q67h61w2t.s[12]++, this.props),
          index = _ref2.index,
          defaultTime = _ref2.defaultTime,
          format = _ref2.format;

      cov_2q67h61w2t.s[13]++;

      if (typeof index === 'number') {
        cov_2q67h61w2t.b[0][0]++;
        cov_2q67h61w2t.s[14]++;
        idx = index;
      } else {
        cov_2q67h61w2t.b[0][1]++;
      }

      cov_2q67h61w2t.s[15]++;

      if (!defaultTime[idx]) {
        cov_2q67h61w2t.b[1][0]++;
        cov_2q67h61w2t.s[16]++;
        return current;
      } else {
        cov_2q67h61w2t.b[1][1]++;
      }

      cov_2q67h61w2t.s[17]++;
      return utils.cloneTime(current, defaultTime[idx], format, this.getOptions());
    }
  }, {
    key: "getValue",
    value: function getValue() {
      cov_2q67h61w2t.f[3]++;
      cov_2q67h61w2t.s[18]++;
      return (cov_2q67h61w2t.b[2][0]++, this.props.value) || (cov_2q67h61w2t.b[2][1]++, this.defaultValue);
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(value, val, mode, onlyVaild) {
      cov_2q67h61w2t.f[4]++;

      var _ref3 = (cov_2q67h61w2t.s[19]++, this.props),
          disabled = _ref3.disabled,
          min = _ref3.min,
          max = _ref3.max,
          range = _ref3.range,
          disabledTime = _ref3.disabledTime,
          index = _ref3.index,
          rangeDate = _ref3.rangeDate;

      var _ref4 = (cov_2q67h61w2t.s[20]++, paramUtils.judgeTimeByRange({
        target: val,
        value: value,
        mode: mode,
        min: min,
        max: max,
        range: range,
        disabled: disabled,
        disabledTime: disabledTime,
        index: index,
        rangeDate: rangeDate,
        options: this.getOptions()
      })),
          _ref5 = _slicedToArray(_ref4, 2),
          isDisabled = _ref5[0],
          date = _ref5[1];

      cov_2q67h61w2t.s[21]++;
      return onlyVaild ? (cov_2q67h61w2t.b[3][0]++, isDisabled) : (cov_2q67h61w2t.b[3][1]++, [isDisabled, date]);
    }
  }, {
    key: "handleChange",
    value: function handleChange(type, val) {
      var _this$props;

      cov_2q67h61w2t.f[5]++;

      var _ref6 = (cov_2q67h61w2t.s[22]++, this.props),
          format = _ref6.format;

      var value = (cov_2q67h61w2t.s[23]++, this.getValue());
      var mode = (cov_2q67h61w2t.s[24]++, type);
      cov_2q67h61w2t.s[25]++;

      if (type === 'hour') {
        cov_2q67h61w2t.b[4][0]++;
        cov_2q67h61w2t.s[26]++;

        if (format.indexOf('h') >= 0) {
          cov_2q67h61w2t.b[5][0]++;
          cov_2q67h61w2t.s[27]++;
          mode = 'h';
        } else {
          cov_2q67h61w2t.b[5][1]++;
          cov_2q67h61w2t.s[28]++;
          mode = 'H';
        }
      } else {
        cov_2q67h61w2t.b[4][1]++;
      }

      var _ref7 = (cov_2q67h61w2t.s[29]++, this.handleDisabled(value, val, mode)),
          _ref8 = _slicedToArray(_ref7, 2),
          isDisabled = _ref8[0],
          date = _ref8[1];

      cov_2q67h61w2t.s[30]++;

      if (isDisabled) {
        cov_2q67h61w2t.b[6][0]++;
        cov_2q67h61w2t.s[31]++;
        return;
      } else {
        cov_2q67h61w2t.b[6][1]++;
      }

      cov_2q67h61w2t.s[32]++;

      (_this$props = this.props).onChange.apply(_this$props, _toConsumableArray(paramUtils.timeHandleChangeParams(date, true, false, true)));
    }
  }, {
    key: "renderTimeScroller",
    value: function renderTimeScroller(value, min, max, hours) {
      cov_2q67h61w2t.f[6]++;

      var _ref9 = (cov_2q67h61w2t.s[33]++, this.props),
          format = _ref9.format,
          hourStep = _ref9.hourStep,
          minuteStep = _ref9.minuteStep,
          secondStep = _ref9.secondStep,
          range = _ref9.range,
          disabled = _ref9.disabled,
          disabledTime = _ref9.disabledTime,
          index = _ref9.index,
          rangeDate = _ref9.rangeDate,
          timeZone = _ref9.timeZone;

      var rtl = (cov_2q67h61w2t.s[34]++, isRTL());
      var res = (cov_2q67h61w2t.s[35]++, [(cov_2q67h61w2t.b[7][0]++, format.indexOf('H') >= 0) && (cov_2q67h61w2t.b[7][1]++,
      /*#__PURE__*/
      React.createElement(TimeScroll, {
        key: "HH",
        current: value,
        value: utils.getDateInfo(value, 'hour', this.getOptions()),
        mode: "H",
        range: range,
        min: min,
        max: max,
        disabled: disabled,
        total: 24,
        step: hourStep,
        onChange: this.handleHourChange,
        disabledTime: disabledTime,
        index: index,
        rangeDate: rangeDate,
        timeZone: timeZone,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118,
          columnNumber: 9
        }
      })), (cov_2q67h61w2t.b[8][0]++, format.indexOf('h') >= 0) && (cov_2q67h61w2t.b[8][1]++,
      /*#__PURE__*/
      React.createElement(TimeScroll, {
        key: "hh",
        current: value,
        mode: "h",
        range: range,
        min: min,
        max: max,
        disabled: disabled,
        value: hours,
        total: 12,
        step: hourStep,
        onChange: this.handleHourChange,
        disabledTime: disabledTime,
        index: index,
        rangeDate: rangeDate,
        timeZone: timeZone,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 137,
          columnNumber: 9
        }
      })), (cov_2q67h61w2t.b[9][0]++, format.indexOf('m') >= 0) && (cov_2q67h61w2t.b[9][1]++,
      /*#__PURE__*/
      React.createElement(TimeScroll, {
        key: "mm",
        current: value,
        mode: "m",
        range: range,
        min: min,
        max: max,
        disabled: disabled,
        value: utils.getDateInfo(value, 'minute', this.getOptions()),
        step: minuteStep,
        onChange: this.handleMinuteChange,
        disabledTime: disabledTime,
        index: index,
        rangeDate: rangeDate,
        timeZone: timeZone,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 9
        }
      })), (cov_2q67h61w2t.b[10][0]++, format.indexOf('s') >= 0) && (cov_2q67h61w2t.b[10][1]++,
      /*#__PURE__*/
      React.createElement(TimeScroll, {
        key: "ss",
        current: value,
        mode: "s",
        range: range,
        min: min,
        max: max,
        disabled: disabled,
        value: utils.getDateInfo(value, 'second', this.getOptions()),
        step: secondStep,
        onChange: this.handleSecondChange,
        disabledTime: disabledTime,
        index: index,
        rangeDate: rangeDate,
        timeZone: timeZone,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 174,
          columnNumber: 9
        }
      })), (cov_2q67h61w2t.b[11][0]++, /a|A/.test(format)) && (cov_2q67h61w2t.b[11][1]++,
      /*#__PURE__*/
      React.createElement(TimeScroll, {
        key: "ampm",
        current: value,
        mode: "ampm",
        range: range,
        min: min,
        max: max,
        disabled: disabled,
        value: utils.getDateInfo(value, 'hour', this.getOptions()) >= 12 ? (cov_2q67h61w2t.b[12][0]++, 1) : (cov_2q67h61w2t.b[12][1]++, 0),
        total: 2,
        ampm: true,
        onChange: this.handleAMPMChange,
        disabledTime: disabledTime,
        index: index,
        rangeDate: rangeDate,
        timeZone: timeZone,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 192,
          columnNumber: 9
        }
      }))]);
      cov_2q67h61w2t.s[36]++;

      if (rtl) {
        cov_2q67h61w2t.b[13][0]++;
        cov_2q67h61w2t.s[37]++;
        res = res.reverse();
      } else {
        cov_2q67h61w2t.b[13][1]++;
      }

      cov_2q67h61w2t.s[38]++;
      return res;
    }
  }, {
    key: "render",
    value: function render() {
      cov_2q67h61w2t.f[7]++;

      var _ref10 = (cov_2q67h61w2t.s[39]++, this.props),
          format = _ref10.format,
          mi = _ref10.min,
          ma = _ref10.max;

      var value = (cov_2q67h61w2t.s[40]++, this.getValue());
      var className = (cov_2q67h61w2t.s[41]++, datepickerClass('time-picker'));
      var hours = (cov_2q67h61w2t.s[42]++, value.getHours());
      cov_2q67h61w2t.s[43]++;

      if ((cov_2q67h61w2t.b[15][0]++, format.indexOf('h') >= 0) && (cov_2q67h61w2t.b[15][1]++, hours >= 12)) {
        cov_2q67h61w2t.b[14][0]++;
        cov_2q67h61w2t.s[44]++;
        hours -= 12;
      } else {
        cov_2q67h61w2t.b[14][1]++;
      } // reset


      var min = (cov_2q67h61w2t.s[45]++, utils.resetTimeByFormat(mi, format, this.getOptions()));
      var max = (cov_2q67h61w2t.s[46]++, utils.resetTimeByFormat(ma, format, this.getOptions()));
      cov_2q67h61w2t.s[47]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 233,
            columnNumber: 12
          }
        }, this.renderTimeScroller(value, min, max, hours))
      );
    }
  }]);

  return Time;
}(PureComponent);

export default Time;